import { createContext } from 'react'
import { WindowLocation } from '@reach/router'

export const LocationContext = createContext<WindowLocation | null>(null)
